import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import loginRequest from '../request/Request';
import {FailedLogin} from './inc/Failed';
import logo from '../assets/img/logo.png'

import "../assets/css/back-style.css";
import "../assets/vendor/bootstrap/css/bootstrap.min.css";
import "../assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "../assets/vendor/boxicons/css/boxicons.min.css";
import "../assets/vendor/simple-datatables/style.css";
import "../assets/css/table-responsive.css";
import "../assets/vendor/remixicon/remixicon.css";

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(<div></div>);

    const navigation = useNavigate();

    useEffect(() => {
        if (localStorage.getItem('token')) {
            navigation(process.env.REACT_APP_ADMIN_URL + '/dashboard', { replace: true });
        }
    }, [navigation]);

    const synchroForm = () => {
        setEmail(document.getElementById('Username').value);
        setPassword(document.getElementById('Password').value);
    }

    const login = async () => {
        const response = await loginRequest(email, password);
        if (response.status === 200) {
            localStorage.setItem('token', response.data.accessToken);
            localStorage.setItem('refreshToken', response.data.refreshToken);
            localStorage.setItem('user', JSON.stringify(response.data));
            localStorage.setItem('lang', null);
            // successLogin();
            navigation(process.env.REACT_APP_ADMIN_URL+'/dashboard');
        } else {
            setError(<FailedLogin message="Vérifier vos identifiants" />)
        }
    }

    return (
        <><main>
            <div className="container">
                <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
                                <div className="d-flex justify-content-center py-4">
                                    <a href="/dashboard" className="logo-axian d-flex align-items-center">
                                        <img src={logo} alt="" />
                                    </a>
                                </div>
                                <div className="card mb-3">
                                    <div className="card-body">
                                        <div className="pt-4 pb-2">
                                            <h2 className="card-title text-center pb-0 fs-4">Connectez-vous à votre compte</h2>
                                            <p className="text-center small">Entrez votre Email & Mot de passe</p>
                                        </div>
                                        <form className="row g-3 needs-validation formulaire" onSubmit={async (e) => { e.preventDefault(); login(); }}>
                                            <div className="col-12">
                                                <label for="yourUsername" className="form-label">Email</label>
                                                <div className="input-group has-validation">
                                                    <span className="input-group-text" id="inputGroupPrepend">@</span>
                                                    <input type="text" name="username" className="form-control" id="Username" onChange={synchroForm} required />
                                                    <div className="invalid-feedback">Please enter your username.</div>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <label for="yourPassword" className="form-label">Mot de passe</label>
                                                <input type="password" name="password" className="form-control" id="Password" onChange={synchroForm} required />
                                                <div className="invalid-feedback">Please enter your password!</div>

                                            </div>
                                            <div className="col-12">
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" name="remember" value="true" id="rememberMe" />
                                                    <label className="form-check-label" for="rememberMe">Se souvenir de moi</label>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <button className=" btn-axian-cramoisie w-100" type='submit'>Se connecter</button>

                                            </div>
                                            {error}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </main></>
    );
}

export default Login;